import React, {useState, useEffect}  from 'react';
import {connect} from 'react-redux';
import {Actions as AUTHENTICATIONACTIONS} from '../../store/actions/authenticationActions';
import Select from 'react-select';

import BuddyFace from '../../images/buddy-face.png';
import { format } from 'date-fns';

const Login = ({
	currentAgreement,
	myAgreements,
	myUpdateCurrentAgreement,
	updateCurrentDepartment,
	currentDepartment,
	departments,
	switchMode,
	mode,
	login,
	resetPassword,
	invalidLoginCredentials,
	accountLockedUntil,
}) => {

  	const [reset, setReset] = useState(window.location.pathname.includes('reset'));
  	const [username, setUsername] = useState();
  	const [password, setPassword] = useState();

  	if (reset){
		return(
			<div className="holder" style={{minHeight: "100vh"}}>
		      <div className="center" id="login">
		        <div className="text-center">
		          <img src={BuddyFace} />
		        </div>
		        <form className="js-validation-login form-horizontal push-30-t novalidate" method="post">
		          <div className="form-group">
		            <div className="col-xs-12">
		              <div className={`form-material form-material-primary floating ${username ? "open" : ""}`}>
		                <input className="form-control" type="text" id="login-username" onChange={(e) => setUsername(e.target.value)}/>
		                  <label htmlFor="login-username">Email</label>
		                
		              </div>
		            </div>
		          </div>
		          <div className="form-group push-30-t">
		            <div className="col-xs-12">
		              <button className="btn btn-block btn-primary" type="submit" onClick={(e) => {
		              	e.preventDefault();
		              	e.stopPropagation();
		              	resetPassword(username)
		              }}>Reset Password</button>
		            </div>
		            <div className="col-xs-12">
		              <div className="font-s13 text-right push-5-t">
		                <a onClick={() => setReset(false)}>Nope, take me back</a>
		              </div>
		            </div>
		          </div>
		        </form>
		      </div>
		    </div>
		)
  	}


	return(
		<div className="holder" style={{minHeight: "100vh"}}>
	      <div className="center" id="login">
	        <div className="text-center">
	          <img src={BuddyFace} />
	        </div>
	        <form className="js-validation-login form-horizontal push-30-t novalidate" method="post">
	          <div className="form-group">
	            <div className="col-xs-12">
	              <div className={`form-material form-material-primary floating ${username ? "open" : ""}`}>
	                <input className="form-control" type="text" autoComplete="current-username" id="login-username" onChange={(e) => setUsername(e.target.value)}/>
	                  <label htmlFor="login-username">Email</label>
	                
	              </div>
	            </div>
	            <div className="col-xs-12">
	              <div className={`form-material form-material-primary floating ${password ? "open" : ""}`}>
	                <input className="form-control" type="password" id="login-password" autoComplete="current-password" onChange={(e) => setPassword(e.target.value)}/>
	                  <label htmlFor="login-password">Password</label>
	                
	              </div>
	            </div>

				{
					accountLockedUntil &&
					<div className="col-xs-12 alert-danger alert">
						<h5 style={{
							textAlign: "left",
						}}>Account Locked</h5>
						<p style={{
							textAlign: "left",
							color: "white",
						}}>
							Your account is locked until {format(new Date(accountLockedUntil), "do MMM yyyy HH:mm aa")}
							<br />
							Please check your email for instructions on how to unlock your account.
						</p>
					</div>
				}
	            {
	            	invalidLoginCredentials &&
		            <div className="col-xs-12 alert-danger alert">
		            	<h5 style={{
		            		textAlign: "left",

		            	}}>Incorrect Username or Password</h5>
		              <ul style={{
					    listStyle: "disc",
					    paddingLeft: "20px",
					    textAlign: "left",
		              }}>
		              	<li>Are you using the right email address?</li>
						<li>Is the first letter of your email address in lowercase?</li>
						<li>If you are unable to log-in, reset your password below.</li>
		              </ul>
		            </div>
		        }
	            <div className="col-xs-6">
	              <label className="css-input switch switch-sm switch-primary">
	                <input type="checkbox" id="login-remember-me" name="login-remember-me" /><span /> Remember Me?
	              </label>
	            </div>
	            <div className="col-xs-6">
	              <div className="font-s13 text-right push-5-t">
	                <a onClick={() => setReset(true)}>Forgot Password?</a>
	              </div>
	            </div>
	          </div>
	          <div className="form-group push-30-t">
	            <div className="col-xs-12 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4">
	              <button className="btn btn-block btn-primary" type="submit" onClick={(e) => {
	              	e.preventDefault();
	              	e.stopPropagation();
	              	login(username,password)
	              }}>Log in</button>
	            </div>
	          </div>
	        </form>
	      </div>
	    </div>
	)
}




const mapStateToProps = (state) => {

  return {
  	profile: state.my.profile,
  	invalidLoginCredentials: state.authentication.invalidLoginCredentials,
	accountLockedUntil: state.authentication.lockedUntil,
  }
}

const mapDispatchToProps = dispatch => ({
  login: (username,password) => dispatch(AUTHENTICATIONACTIONS.login(username,password)),
  resetPassword: (username) => dispatch(AUTHENTICATIONACTIONS.resetPassword(username)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login) 
